import { render, staticRenderFns } from "./ChatDock.vue?vue&type=template&id=a0880728&scoped=true"
import script from "./ChatDock.vue?vue&type=script&lang=js"
export * from "./ChatDock.vue?vue&type=script&lang=js"
import style0 from "./ChatDock.vue?vue&type=style&index=0&id=a0880728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0880728",
  null
  
)

export default component.exports